import React, { useMemo } from "react";
import styled from "styled-components";
import { useStore } from "stores/connect";
import CounterRate from "./CounterRate";
import ForwarderInputStatesStore from "../stores/ForwarderInputStatesStore";
const StyledP = styled.p`
  margin-bottom: 0;
`;
const ForwarderInputMetricContainer = ({ input, forwarder }) => {
  const { forwarderInputStates: states } = useStore(ForwarderInputStatesStore);
  const currentInputMetric = useMemo(() => {
    var _a, _b;
    const statesByInput = (states || []).filter((state) => state.input_id === input.id);
    if (!forwarder) {
      return null;
    }
    return (_b = (_a = statesByInput.filter((state) => state.forwarder_id === forwarder.id)[0]) == null ? void 0 : _a.metrics) == null ? void 0 : _b.filter((metric) => metric.name === "incomingMessages");
  }, [input, forwarder, states]);
  const hasResults = currentInputMetric && currentInputMetric.length > 0;
  if (!hasResults) {
    return /* @__PURE__ */ React.createElement(StyledP, null, "No metrics available.");
  }
  return /* @__PURE__ */ React.createElement(StyledP, null, /* @__PURE__ */ React.createElement(CounterRate, { metric: currentInputMetric[0], suffix: "msg/s" }), " averaged in the last minute.");
};
export default ForwarderInputMetricContainer;
